import React from 'react';
import FillPreview from '../FillPreview/FillPreview';
import { classes } from './Palette.st.css';
import { PaletteProps } from './Palette.types';

const Palette = ({ dataHook, fill = [] }: PaletteProps) => {
  return (
    <div className={classes.root} data-hook={dataHook}>
      {fill.map((item, i) => (
        <FillPreview
          as="div"
          key={i}
          tabIndex={-1}
          className={classes.fillPreview}
          aspectRatio="none"
          fill={item}
        />
      ))}
    </div>
  );
};

Palette.displayName = 'Palette';

export default Palette;
